import {
    GET_BLEMISH_REPORT_REQUEST,
    GET_BLEMISH_REPORT_SUCCESS,
    GET_BLEMISH_REPORT_FAILURE,
    GET_BLEMISH_FIELD_SUCCESS,
} from '../../constants/questions_constants/get_blemish_report.constants';

export const getBlemishReportRequest = (lead_id, field) => ({
    type: GET_BLEMISH_REPORT_REQUEST,
    lead_id,
    field,
});

export const getBlemishReportSuccess = (questions) => ({
    type: GET_BLEMISH_REPORT_SUCCESS,
    questions,
});

export const getBlemishFieldSuccess = (payload, field) => ({
    type: GET_BLEMISH_FIELD_SUCCESS,
    field,
    payload,
});

export const getBlemishReportFailure = (error) => ({
    type: GET_BLEMISH_REPORT_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/questions_actions/get_blemish_report.actions.js